import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import BlogPage from "./pages/BlogPage";
import DetailPage from "./pages/DetailPage";
import Collections from "./pages/Collections";
import Favorites from "./pages/Favorites";
import MyDiscussions from "./pages/MyDiscussions";
import About from "./pages/About";
import ComingSoon from "./pages/ComingSoon";
import DocumentList from "./pages/DocumentList";
import Register from "./pages/Register";
import Logout from "./pages/Logout";
import ResetPassword from "./pages/ResetPassword";
import CookiePolicy from "./pages/CookiePolicy";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ContactPage from "./pages/ContactPage";
import SearchResultsList from "./pages/SearchResultsList";
import UserPreferences from "./pages/UserPreferences";
import Verify from "./pages/Verify";
import Leanings from "./pages/Leanings";
import SenateCandidates from "./pages/SenateCandidates";
import axios from "axios";
import SenateSideBySide from "./pages/SenateSideBySide";
import ExecutiveOrders from "./pages/ExecutiveOrders";
import HouseCandidates from "./pages/HouseCandidates";
import HouseSideBySide from "./pages/HouseSideBySide";
import ErrorPage from "./pages/ErrorPage";
import Placard from "./pages/Placard";


// Force Axios to include cookies on every single request
axios.defaults.withCredentials = true;
axios.defaults.baseURL = '/';



if (process.env.NODE_ENV === 'production') {
  console.log = () => { };
  console.info = () => { };
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorPage />,
  },

  {
    path: "/Blog",
    element: <BlogPage />,
  },
  {
    path: "/Logout",
    element: <Logout />,
  },
  {
    path: "/ResetPassword",
    element: <ResetPassword />,
  },
  {
    path: "/Collections",
    element: <Collections />,
  },
  {
    path: "/Favorites",
    element: <Favorites />,
  },
  {
    path: "/MyDiscussions",
    element: <MyDiscussions />,
  },
  {
    path: "/About.html",
    element: <About />,
  },
  {
    path: "/CookiePolicy.html",
    element: <CookiePolicy />,
  },
  {
    path: "/Contact.html",
    element: <ContactPage />,
  },
  {
    path: "/PrivacyPolicy.html",
    element: <PrivacyPolicy />,
  },

  {
    path: "/ComingSoon.html",
    element: <ComingSoon />,
  },
  {
    path: "/Register.html",
    element: <Register />,
  },

  {
    path: "/Presidents/:metaNumber/:signatory",
    element: <DocumentList />,
  },

  {
    path: "/DocumentList/:collectionId/:metaNumber/:signatory",
    element: <DocumentList />,
  },

  {
    path: "/SearchResultsList",
    element: <SearchResultsList />,
  },

  {
    path: "/Details/:id/:urlTitle",
    element: <DetailPage />,
  },

  {
    path: "/Placard/:id/:urlTitle",
    element: <Placard />,
  },

  {
    path: "/UserPreferences",
    element: <UserPreferences />
  },

  {
    path: "/Verify/:userHash",
    element: <Verify />
  },

  {
    path: "/WhereDoILean.html",
    element: <Leanings />
  },

  {
    path: "/Senate2026.html",
    element: <SenateCandidates />
  },

  {
    path: "/Senate/:year/:state",
    element: <SenateSideBySide />
  },
  {
    path: "/ExecutiveOrders.html",
    element: <ExecutiveOrders />
  },
  {
    path: "/House2026.html",
    element: <HouseCandidates />
  },
  {
    path: "/House/:year/:state/:district",
    element: <HouseSideBySide />
  }




]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<RouterProvider router={router} />);
